import React, { useContext } from 'react'
import { WemoloAccordion } from '../../../components/Wemolo'
import { DeviceTypeEnum } from '../../../data/enums'
import { DeviceContext } from '.././DeviceContext'
import { SendCommand } from '../Sms'
import styles from './ActionsWrapper.module.css'

export const ActionsWrapper = () => {
    const deviceContext = useContext(DeviceContext)

    return (
        <div className={styles.root}>
            {deviceContext.getSelectedDeviceType() === DeviceTypeEnum.SCANNER && (
                <WemoloAccordion title="Send SMS Command to Truephone" defaultExpanded={true}>
                    <div className={styles.smsBody}>
                        <SendCommand />
                    </div>
                </WemoloAccordion>
            )}
        </div>
    )
}
